var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReadingSpanish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #ff9000;\n      }\n\n      .cls-4 {\n        fill: none;\n      }\n\n      .cls-4, .cls-3 {\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "3.22 12 3.22 36 24 48 44.78 36 44.78 12 24 0 3.22 12"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.93,11.46c-5.28,0-9.57,3.46-9.57,7.73,0,1.91.86,3.66,2.28,5.01l-.68,4.81,5.58-2.34h0c.76.15,1.56.25,2.39.25,5.28,0,9.57-3.46,9.57-7.73s-4.28-7.73-9.57-7.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.09,20.39c-5.28,0-9.57,3.46-9.57,7.73,0,1.91.86,3.66,2.28,5.01l-.68,4.81,5.58-2.34h0c.76.15,1.56.25,2.39.25,5.28,0,9.57-3.46,9.57-7.73s-4.28-7.73-9.57-7.73Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadingSpanish);
export default __webpack_public_path__ + "static/media/reading-spanish.63d26c09f0128b3e9f2ae35994480a7d.svg";
export { ForwardRef as ReactComponent };